import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ConfirmPopup from './ConfirmPopup';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface PriceListItem {
    id: number;
    distributor: string;
    singlePrice: number;
    threePhasePrice: number;
    statusId: number;
    isDirty: boolean;
}

const AdminPriceListPowerPoleConnectionData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [powerPoleConnectionItems, setPowerPoleConnectionItems] = React.useState<PriceListItem[]>([]);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=AdminPricelistsView&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                getPriceListPowerPoleConnectionData();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    const getPriceListPowerPoleConnectionData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/PriceList/GetPriceListPowerPoleConnections?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            let ppConnections = res.data;
            let newBlankRow = addBlankRow();
            ppConnections.push(newBlankRow);

            setPowerPoleConnectionItems(ppConnections);
            setLoading(false);
        }).catch(error => {
            toast.error(error.message);
        });
    }

    const addBlankRow = () => {
        let powerPoleItem: PriceListItem = {
            id: 0,
            distributor: "",
            singlePrice: 0,
            threePhasePrice: 0,
            statusId: 1,
            isDirty: false
        };

        return powerPoleItem;
    }

    const handleCellChangeText = (e: any, itemIndex: number) => {
        let error = errors;
        delete error["pricelistitems"];

        var newValue = e.target.value;
        let plItems = [...powerPoleConnectionItems];
        let plItem = plItems[itemIndex];

        let updatedPlItem: any = {};
        updatedPlItem = plItem;
        updatedPlItem[e.target.name] = newValue;
        updatedPlItem["isDirty"] = true;

        if (itemIndex == (powerPoleConnectionItems.length - 1)) {
            //add new row
            var newRow = addBlankRow();
            plItems.push(newRow);
        }

        setPowerPoleConnectionItems(plItems);
    }

    const handleCellChangeNumber = (e: any, itemIndex: number) => {
        let error = errors;
        delete error["pricelistitems"];

        var newValue = e.target.value * 1;
        let plItems = [...powerPoleConnectionItems];
        let plItem = plItems[itemIndex];

        let updatedPlItem: any = {};
        updatedPlItem = plItem;
        updatedPlItem[e.target.name] = newValue;
        updatedPlItem["isDirty"] = true;

        if (itemIndex == (powerPoleConnectionItems.length - 1)) {
            //add new row
            var newRow = addBlankRow();
            plItems.push(newRow);
        }

        setPowerPoleConnectionItems(plItems);
    }

    //DELETE PRICELIST ITEM
    const deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        setShowDeleteConfirm(true);
        setDeleteIndex(itemIndex);
    }

    const hideDeleteConfirm = () => {
        setShowDeleteConfirm(false);
        setDeleteIndex(-1);
    }

    const saveDeleteConfirm = () => {
        var pricelist = [...powerPoleConnectionItems];
        var pricelistItem = pricelist[deleteIndex];

        if (pricelistItem.id === 0) {
            //just remove from the list as not saved
            pricelist.splice(deleteIndex, 1);
            setShowDeleteConfirm(false);
            setDeleteIndex(-1);
            setPowerPoleConnectionItems(pricelist);

            toast.success("Item deleted successfully");
        } else {
            saveDeletePricelist(pricelist, pricelistItem.id);
        }
    }

    const saveDeletePricelist = async (pricelist: PriceListItem[], powerPoleId: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var deletePriceList = {
            id: powerPoleId,
            subId: user.sub
        };

        axios.post('api/PriceList/DeletePriceListPowerPoleConnection', deletePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                    };
                } else {
                    toast.success("Price List Saved Successfully");
                    pricelist.splice(deleteIndex, 1);
                    setShowDeleteConfirm(false);
                    setDeleteIndex(-1);
                    setPowerPoleConnectionItems(pricelist);
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    }
    //END DELETE PRICELIST ITEM

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;
        let items = powerPoleConnectionItems;

        if (powerPoleConnectionItems.length === 1) {
            errorList["pricelistitems"] = "Please enter at least one item!";
            setErrors(errorList)
            return true;
        }

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < items.length - 1; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (!items[i].distributor || items[i].distributor === "") {
                newErrorString += "Distributor, ";
                error = true;
            }

            if (items[i].singlePrice <= 0) {
                newErrorString += "Single Phase Price, ";
                error = true;
            }

            if (items[i].threePhasePrice <= 0) {
                newErrorString += "3 Phase Price, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errorList["pricelistitems"] = errorString;
        }
        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            var changed = powerPoleConnectionItems.filter(p => p.isDirty);

            if (changed.length === 0) {
                toast.info("No items have changed.");
            } else {
                savePricelist(changed);
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const savePricelist = async (changed: PriceListItem[]) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var savePriceList = {
            items: changed,
            subId: user.sub
        };

        axios.post('api/PriceList/SavePriceListPowerPoleConnections', savePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Power Pole Connections Saved Successfully");
                setLoading(true);
                getPriceListPowerPoleConnectionData();
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const lastRow = powerPoleConnectionItems.length - 1;
    const confirmPopup = <ConfirmPopup heading="Delete Power Pole Item?" text="Are you sure you want to delete this power pole connection item?" hideConfirmModal={hideDeleteConfirm} showConfirmModal={showDeleteConfirm} saveConfirmModal={saveDeleteConfirm} />

    const renderDetails = (
        <div>
            <div className="static-modal">
                {confirmPopup}
            </div>
            <div className="overflowAuto">
                <table className="table table--nowidth tableColours">
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th></th>
                            <th>Distributor</th>
                            <th>Single Price</th>
                            <th>3 Phase Price</th>
                            <th></th>
                        </tr>
                    </thead>
                    {powerPoleConnectionItems.map((item, index) =>
                        <tbody key={index}>
                            <tr>
                                <td className="hidden">{item.id}</td>
                                <td className="table__text--align">{index + 1}</td>
                                <td className="table__text--align">
                                    <input type='text' maxLength={50} className='form-control' id="distributor" name="distributor" value={item.distributor} onChange={(e) => handleCellChangeText(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='form-control textalignright' id="singlePrice" name="singlePrice" value={item.singlePrice} onChange={(e) => handleCellChangeNumber(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='form-control textalignright' id="threePhasePrice" name="threePhasePrice" value={item.threePhasePrice} onChange={(e) => handleCellChangeNumber(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <div className={index === lastRow ? "hidden" : "delete--tablecell"}>
                                        <a className="makeitred" href="#" onClick={(e) => deleteItem(e, index)}>
                                            <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
                {errors["pricelistitems"] ?
                    (errors["pricelistitems"]).split("\n").map((item: any, key: any) => {
                        return <span className="label errors" key={key}>{item}<br /></span>
                    })
                    : ""}
            </div>
            <div className="marginBottom10">
                <button className="defaultbutton defaultbutton__large" type="button" onClick={save} disabled={loading ? true : false}>Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Power Pole Connection Prices</h1>
            {contents}
        </div>
    );
}

export default AdminPriceListPowerPoleConnectionData;